import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/trash_copy.svg',
})
export class TrashComponent {}
